import clsx from 'clsx';
import { memo } from 'react';

import * as styles from './styles.module.scss';

const confettiLength = Array.from({ length: 100 }, (_, i) => i);

const Confetti = () => (
  <div className={styles['confetti__wrapper']}>
    {confettiLength.map((i) => (
      <div key={`confetti--${i}`} className={clsx(styles.confetti, styles[`confetti--${i}`])} />
    ))}
  </div>
);
export default memo(Confetti);
